var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        [
          _c("stepheader", { attrs: { step: _vm.step } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body current",
              attrs: {
                id: "wizard2-p-0",
                role: "tabpanel",
                "aria-labelledby": "wizard2-h-0",
                "aria-hidden": "false",
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6 col-lg-6" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.imei,
                        expression: "imei",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "imei",
                      name: "imei",
                      placeholder: "inserisci imei",
                      required: "",
                      type: "text",
                    },
                    domProps: { value: _vm.imei },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.imei = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 col-lg-6" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cardnumber,
                        expression: "cardnumber",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "cardnumber",
                      name: "vatnumber",
                      placeholder: "card number",
                      required: "",
                      type: "text",
                    },
                    domProps: { value: _vm.cardnumber },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.cardnumber = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("buttons", {
                attrs: { buttons: _vm.step.buttons },
                on: { action: _vm.fireaction },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-label", attrs: { for: "imei" } }, [
      _vm._v("Imei: "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label", attrs: { for: "vatnumber" } },
      [
        _vm._v("Card Number: "),
        _c("span", { staticClass: "tx-danger" }, [_vm._v("*")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }